import './src/scss/theme.scss'
import('../../src/js/app')
